/**
 * Convercus BI Service
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { KpiValueFormat } from './kpi-value-format';
import { TimeGrain } from './time-grain';
import { ChartConfigurationSchema } from './chart-configuration-schema';
import { TrendComparisonSetting } from './trend-comparison-setting';


export interface CreateArtifactDto { 
    /**
     * Metric presentation type. count, amount and percentage render one value; trend returns one row per time bucket (bucket, value) and needs valueFormat, period and timeGrain; chart requires chartConfig.
     */
    type: CreateArtifactDto.TypeEnum;
    /**
     * Read-only SQL with real values. It may reference {{period.from}} / {{period.to}} when period is sent, and a trend buckets by {{timeGrain.unit}} / {{timeGrain.interval}}; no other placeholders. The artifact stores the SQL with those bound.
     */
    sql: string;
    /**
     * How a trend artifact\'s values are formatted. Required when type is trend; must be omitted for every other type.
     */
    valueFormat?: KpiValueFormat;
    /**
     * The dates the answer covers, as a Metabase date string (past90days~, 2026-08, 2026-01-01~2026-03-31, …); returned resolved as period. Required when type is trend: the server widens it to whole buckets and to the compared buckets, and binds that window to {{period.from}} / {{period.to}}.
     */
    period?: string;
    /**
     * The bucket size a trend artifact groups by, bound to {{timeGrain.unit}} / {{timeGrain.interval}}. Required when type is trend; must be omitted for every other type.
     */
    timeGrain?: TimeGrain;
    /**
     * Trend only: what the latest complete bucket is compared with. Omitted or null means [{ type: previous_period }]. The list rules: at most 3 entries in display order, each previous_period, same_period_last_year, periods_ago (value: whole number 2–60, in the tile\'s grain) or static_number (value: the target, label: 1–40 characters); no repeats, at most one static_number.
     */
    comparisons?: Array<TrendComparisonSetting> | null;
    /**
     * Required when type is chart; must be null or omitted for scalar metric types.
     */
    chartConfig?: ChartConfigurationSchema | null;
    /**
     * Short human-readable title; derived from the question if omitted.
     */
    title?: string;
    /**
     * The natural-language question this metric answers (free text).
     */
    question?: string;
    /**
     * Id of the successful runQuery or executeKpi execution this answer came from. Its rows are used instead of running the SQL again; the SQL (with period bound) must be exactly the SQL that execution ran, else ARTIFACT_EXECUTION_MISMATCH.
     */
    executionId?: string;
}
export namespace CreateArtifactDto {
    export const TypeEnum = {
        Amount: 'amount',
        Count: 'count',
        Chart: 'chart',
        Percentage: 'percentage',
        Trend: 'trend'
    } as const;
    export type TypeEnum = typeof TypeEnum[keyof typeof TypeEnum];
}


